module.exports = __webpack_public_path__ + "static/media/TowerIconGray.5f12b003.svg";